// extracted by mini-css-extract-plugin
export default {"in_stock":"InStock-module__in_stock--aatpm","in_stock__inner":"InStock-module__in_stock__inner--cYhL5","in_stock__title":"InStock-module__in_stock__title--qKkvm"};